import { NAV_BRAND, TRACKING_GLOBALS } from '@/config'
import { PORTAL_TYPE_RJA } from '@/config/constants'

const initPJA = () => {
  if (NAV_BRAND.portal_type === PORTAL_TYPE_RJA) {
    TRACKING_GLOBALS.isPjaEntry = true
  }
}

export default initPJA
